import { gql } from '@apollo/client';

export default gql`
  query ViewerQuery {
    viewer {
      id
      email
      name
      role
      username

      workspaceProducers {
        nodes {
          id
          name
          slug
        }
      }
    }
  }
`;
